var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"layoutC"},[_c('router-link',{staticClass:"btn",attrs:{"to":("/mypage/" + _vm.id + "/")}},[_c('span',[_vm._v("マイページに戻る")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }